import { css } from '@emotion/react';
import { ReactElement, ReactNode, useCallback } from 'react';
import { HoldStore, InvolveStore } from 'sdk';

import { styled } from '../../styled';
import { Theme } from '../../theme/interface/detailed';
import { InvolveHeader } from '../involve/involveHeader';
import { HeaderContainer } from './headerContainer';

type Interface = { className: string; children: ReactNode; store: InvolveStore | HoldStore };

const styles = css`
	display: flex;
	flex-flow: column;
	margin-bottom: 20px;
	max-width: 100%;
	padding: 5px 0;
	position: relative;
	width: 300px;
`;

const Component = ({ className, store, children }: Interface): ReactElement => {
	const onCloseClick = useCallback(() => {
		store.disableActiveInteraction();
		store.resume();
	}, [store]);

	return (
		<>
			<HeaderContainer isInvolve onCloseClick={onCloseClick}>
				<InvolveHeader />
			</HeaderContainer>
			<div className={className}>{children}</div>
		</>
	);
};

export const InvolveContainer = styled(Component)(
	({
		theme: {
			allSettings: {
				containers: {
					// eslint-disable-next-line @typescript-eslint/no-unused-vars
					chatContainer: { height, borderRadius: br, ...others },
				},
			},
		},
	}: {
		theme: Theme;
	}) => ({
		...others,
		borderRadius: `0 0 ${br} ${br}`,
	}),
	styles
);
